<script>
	import { onMount } from 'svelte';
	import { beforeUpdate } from 'svelte';

    import { cuenta } from './../controlador/store.js';
    let load;
    let img;
</script>
<div class="container scroll"><!-- este es el q puede scrolear en todos-->
	<h2>Datos de la cuenta</h2>
	<div class="contenido">
		<div class="fila">
			<div class="dato">
				<span>Nombre: </span>{$cuenta.nombre}
			</div>
		</div>
		<div class="fila">
			<div class="dato">
				<span>Titulo: </span>{$cuenta.titulo}
			</div>
			<div class="dato">
				<span>Matricula: </span>{$cuenta.matricula}
			</div>
		</div>
	</div>
	<div class="fila">
		<a href='#/editar/cuenta' class="boton"><i class="ph-pencil-line left"></i>Editar Datos</a>
		<a href="#/cambiar/firma" class="boton"><i class="ph-pen-nib left"></i>Cambiar Firma</a>
	</div>	
</div>

<style>
	.contenido{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	span{
		font-weight: bold;
	}
	h2{
		color: white;
		width: 100%;
		padding: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.fila{
		margin: auto;
		width: 100%;
		max-width: 380px;
		padding: 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: white;
	}
	.boton{
		background: transparent;
		border: none;
		outline: none;
		cursor: pointer;
		color: white;
		margin: 10px;
		padding: 5px;
		text-decoration: none;
	}
	.flotante{
		position: fixed;
		bottom: 20px;
		right: 20px;
		width: 50px;
		height: 50px;
		border-radius: 25px;
		background:linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(207,215,255,1) 100%);
		border:none;
		outline: none;
		color: var(--azul);
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 30px;
		cursor: pointer;
		text-decoration: none;
		z-index: 200;
	}
	.flotante > i{
		margin-top: 5px;
	}
</style>